import { Selectorispogzpkkfxv as Selector } from './Selector.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { text189ciz0cnr32o as text } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { default1jaun537xukbl as default_0 } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Defaults.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import { nullElement39ujy5fzowmto as nullElement } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { RenderContextxikz99gtpuie as RenderContext } from './RenderContext.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { ReactiveState__getOrNull_impl_1asnfp338k3yl4xmyxq as ReactiveState__getOrNull_impl_1asnfp } from '../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { Checkbox2he0oy51inwu6 as Checkbox } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Checkbox.commonHtml.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  weight31wqab1913ly4 as weight,
  textPopover3tarprbgmgxbr as textPopover,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { SwapView1526g6cz7z56r as SwapView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/SwapView.commonHtml.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Companion_getInstance29ka8gqgdrya1 as Companion_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/ScreenTransitions.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { report1vfr9zf0i9d9p as report } from '../../../../../kiteui-library/com/lightningkite/kiteui/debugger.mjs';
import { reactive2xic0rufq5s8n as reactive } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  LabelGapSemantic_getInstance2wftjv243mafi as LabelGapSemantic_getInstance,
  LabelSemantic_getInstance4iffxvo6ijig as LabelSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import {
  get_rem14pbkv8p42gid as get_rem,
  get_rem2p56fiaxda5jo as get_rem_0,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { Companion_getInstance23x6zslwzj0st as Companion_getInstance_0 } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import { errorText83fzxqvlxz6i as errorText } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import {
  cellFormub3o1hqp20e5 as cellForm,
  Renderer1fhwti5gmwutm as Renderer,
} from './Renderer.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function registerNullable(_this__u8e3s4) {
  _this__u8e3s4.register_9awv9l_k$(new (Selector())(), NullableRenderer_instance);
}
function NullableRenderer$form$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function NullableRenderer$form$lambda$lambda(it) {
  return !(it == null);
}
function NullableRenderer$form$lambda$lambda$lambda$lambda(it) {
  return it;
}
function NullableRenderer$form$lambda$lambda$lambda($next, $value, $innerRenderer, $innerContext, $module, $ifNotNull) {
  return ($this$swap) => {
    if ($next) {
      var tmp = (it) => it == null ? $ifNotNull._v : it;
      var nonNullValue = $value.lens_drj4fu_k$(tmp, NullableRenderer$form$lambda$lambda$lambda$lambda);
      $innerRenderer.form_gie6yk_k$($innerContext, nonNullValue, $module)($this$swap);
    } else {
      text($this$swap, 'N/A');
    }
    return Unit_instance;
  };
}
function NullableRenderer$view$lambda(_this__u8e3s4) {
  text(_this__u8e3s4, '\u2014');
  return Unit_instance;
}
function NullableRenderer$view$lambda$lambda$lambda($next, $value, $innerRenderer, $innerContext, $module, $innerSerializer) {
  return ($this$swap) => {
    if ($next) {
      var nonNullValue = lens($value, (it) => it == null ? default_0($innerSerializer) : it);
      $innerRenderer.view_bqdmap_k$($innerContext, nonNullValue, $module)($this$swap);
    } else {
      text($this$swap, '\u2014');
    }
    return Unit_instance;
  };
}
function NullableRenderer$cellView$lambda(_this__u8e3s4) {
  text(_this__u8e3s4, '\u2014');
  return Unit_instance;
}
function NullableRenderer$cellView$lambda$lambda$lambda($next, $value, $innerRenderer, $innerContext, $module, $innerSerializer) {
  return ($this$swap) => {
    if ($next) {
      var nonNullValue = lens($value, (it) => it == null ? default_0($innerSerializer) : it);
      $innerRenderer.cellView_2dvin1_k$($innerContext, nonNullValue, $module)($this$swap);
    } else {
      text($this$swap, '\u2014');
    }
    return Unit_instance;
  };
}
var NullableRendererClass;
function NullableRenderer() {
  if (NullableRendererClass === VOID) {
    class $ {
      constructor() {
        this.name_1 = 'Optional';
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      priority_dgaouj_k$(context, module_0) {
        return context.serializer_1.get_descriptor_wjt6a0_k$().get_isNullable_67sy7o_k$() ? 0.4 : -1.0;
      }
      priority_yxj3hb_k$(context, module_0) {
        return this.priority_dgaouj_k$(context, module_0);
      }
      form_q74x24_k$(context, value, module_0) {
        var tmp = nullElement(context.serializer_1);
        var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, KSerializer()) : false) ? tmp : null;
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          return NullableRenderer$form$lambda;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var innerSerializer = tmp_0;
        var innerContext = new (RenderContext())(innerSerializer, context.fieldAnnotations_1);
        var innerRenderer = module_0.select_mv5knr_k$(innerContext);
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(false);
          var tmp0_elvis_lhs = ReactiveState__getOrNull_impl_1asnfp(value.get_state_wc71uu_k$());
          var ifNotNull = {_v: tmp0_elvis_lhs == null ? default_0(innerSerializer) : tmp0_elvis_lhs};
          // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
          var this_0 = get_centered(element);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (Checkbox())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          this_0.willAddChild_hz2iwc_k$(element_0);
          var tmp = NullableRenderer$form$lambda$lambda;
          element_0.bind_gesskf_k$(element_0.checked_1, value.lens_u4wb4z_k$(tmp, (original, checked) => {
            var tmp;
            if (checked) {
              tmp = original == null ? ifNotNull._v : original;
            } else {
              tmp = null;
            }
            return tmp;
          }));
          element_0.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element_0);
          var nn = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
            var current = $this$remember.invoke_r7m7el_k$(value);
            var tmp;
            if (!(current == null)) {
              ifNotNull._v = current;
              tmp = Unit_instance;
            }
            return !(current == null);
          });
          // Inline function 'com.lightningkite.kiteui.views.expanding' call
          // Inline function 'com.lightningkite.kiteui.views.direct.swapView' call
          var this_1 = weight(element, 1.0);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (SwapView())(this_1.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          this_1.willAddChild_hz2iwc_k$(element_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
          var this_2 = element_1;
          var queue = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
          var alreadySwapping = {_v: false};
          reactive(this_2, 8, ($this$reactive) => {
            var c = $this$reactive.invoke_r7m7el_k$(nn);
            queue.add_utx5q5_k$(c);
            var tmp;
            if (alreadySwapping._v) {
              return Unit_instance;
            }
            alreadySwapping._v = true;
            $l$loop: while (true) {
              // Inline function 'kotlin.collections.isNotEmpty' call
              if (!!queue.isEmpty_y1axqb_k$()) {
                break $l$loop;
              }
              var next = queue.removeAt_6niowx_k$(0);
              try {
                var tmp_0 = Companion_getInstance().Fade_1;
                this_2.swap_26x94b_k$(tmp_0, NullableRenderer$form$lambda$lambda$lambda(next, value, innerRenderer, innerContext, module_0, ifNotNull));
              } catch ($p) {
                if ($p instanceof Exception()) {
                  var e = $p;
                  report(Exception().new_kotlin_Exception_9qyiel_k$('Failed to render ' + toString(next), e), 'SwapView.swapping');
                } else {
                  throw $p;
                }
              }
            }
            alreadySwapping._v = false;
            return Unit_instance;
          });
          element_1.onStartup_vrxh3i_k$();
          this_1.addChild_2qpft2_k$(element_1);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_q74x24_k$(context, value, module_0);
      }
      view_hsl4in_k$(context, value, module_0) {
        var tmp = nullElement(context.serializer_1);
        var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, KSerializer()) : false) ? tmp : null;
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          return NullableRenderer$view$lambda;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var innerSerializer = tmp_0;
        var innerContext = new (RenderContext())(innerSerializer, context.fieldAnnotations_1);
        var innerRenderer = module_0.select_mv5knr_k$(innerContext);
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.swapView' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (SwapView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
          var this_0 = element;
          var queue = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
          var alreadySwapping = {_v: false};
          reactive(this_0, 8, ($this$reactive) => {
            var c = !($this$reactive.invoke_r7m7el_k$(value) == null);
            queue.add_utx5q5_k$(c);
            var tmp;
            if (alreadySwapping._v) {
              return Unit_instance;
            }
            alreadySwapping._v = true;
            $l$loop: while (true) {
              // Inline function 'kotlin.collections.isNotEmpty' call
              if (!!queue.isEmpty_y1axqb_k$()) {
                break $l$loop;
              }
              var next = queue.removeAt_6niowx_k$(0);
              try {
                var tmp_0 = Companion_getInstance().Fade_1;
                this_0.swap_26x94b_k$(tmp_0, NullableRenderer$view$lambda$lambda$lambda(next, value, innerRenderer, innerContext, module_0, innerSerializer));
              } catch ($p) {
                if ($p instanceof Exception()) {
                  var e = $p;
                  report(Exception().new_kotlin_Exception_9qyiel_k$('Failed to render ' + toString(next), e), 'SwapView.swapping');
                } else {
                  throw $p;
                }
              }
            }
            alreadySwapping._v = false;
            return Unit_instance;
          });
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_hsl4in_k$(context, value, module_0);
      }
      cellView_v4jtjx_k$(context, value, module_0) {
        var tmp = nullElement(context.serializer_1);
        var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, KSerializer()) : false) ? tmp : null;
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          return NullableRenderer$cellView$lambda;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var innerSerializer = tmp_0;
        var innerContext = new (RenderContext())(innerSerializer, context.fieldAnnotations_1);
        var innerRenderer = module_0.select_mv5knr_k$(innerContext);
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.swapView' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (SwapView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
          var this_0 = element;
          var queue = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
          var alreadySwapping = {_v: false};
          reactive(this_0, 8, ($this$reactive) => {
            var c = !($this$reactive.invoke_r7m7el_k$(value) == null);
            queue.add_utx5q5_k$(c);
            var tmp;
            if (alreadySwapping._v) {
              return Unit_instance;
            }
            alreadySwapping._v = true;
            $l$loop: while (true) {
              // Inline function 'kotlin.collections.isNotEmpty' call
              if (!!queue.isEmpty_y1axqb_k$()) {
                break $l$loop;
              }
              var next = queue.removeAt_6niowx_k$(0);
              try {
                var tmp_0 = Companion_getInstance().Fade_1;
                this_0.swap_26x94b_k$(tmp_0, NullableRenderer$cellView$lambda$lambda$lambda(next, value, innerRenderer, innerContext, module_0, innerSerializer));
              } catch ($p) {
                if ($p instanceof Exception()) {
                  var e = $p;
                  report(Exception().new_kotlin_Exception_9qyiel_k$('Failed to render ' + toString(next), e), 'SwapView.swapping');
                } else {
                  throw $p;
                }
              }
            }
            alreadySwapping._v = false;
            return Unit_instance;
          });
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      cellView_2dvin1_k$(context, value, module_0) {
        return this.cellView_v4jtjx_k$(context, value, module_0);
      }
      columnWidth_a9nnq7_k$(context, module_0) {
        var tmp0_elvis_lhs = nullElement(context.serializer_1);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return null;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var innerSerializer = tmp;
        var innerContext = new (RenderContext())(innerSerializer, context.fieldAnnotations_1);
        var tmp1_safe_receiver = module_0.columnWidth_g5mvjx_k$(innerContext);
        var tmp_0;
        if (tmp1_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_0 = tmp1_safe_receiver + 2;
        }
        return tmp_0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_a9nnq7_k$(context, module_0);
      }
      labeledForm_jdnfre_k$(context, value, module_0, label, description) {
        return (_this__u8e3s4) => {
          var tmp2 = label;
          // Inline function 'com.lightningkite.kiteui.forms.fieldWithoutBorder' call
          var description_0 = description;
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(true);
          element.set_themeChoice_py59um_k$(element.get_themeChoice_22tyn3_k$().plus_duvq05_k$(LabelGapSemantic_getInstance()));
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          element.willAddChild_hz2iwc_k$(element_0);
          element_0.set_vertical_nuap32_k$(false);
          element_0.set_gap_jwjroq_k$(get_rem(0.25));
          text(themed(get_centered(element_0), LabelSemantic_getInstance()), tmp2);
          if (!(description_0 == null)) {
            var tmp0 = textPopover(get_centered(element_0), description_0);
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            var icon = Companion_getInstance_0().info_1.resize_q1xpz0_k$(get_rem_0(1));
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_1 = new (IconView())(tmp0.get_context_h02k06_k$());
            ensureOutermostElement(element_1);
            tmp0.willAddChild_hz2iwc_k$(element_1);
            element_1.set_source_3o5lkf_k$(icon);
            element_1.set_description_s1386w_k$('Info');
            element_1.onStartup_vrxh3i_k$();
            tmp0.addChild_2qpft2_k$(element_1);
          }
          element_0.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_0);
          NullableRenderer_instance.form_q74x24_k$(context, value, module_0)(element);
          errorText(element);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      labeledForm_ughtr2_k$(context, value, module_0, label, description) {
        return this.labeledForm_jdnfre_k$(context, value, module_0, label, description);
      }
      labeledView_rlcwih_k$(context, value, module_0, label, description) {
        return (_this__u8e3s4) => {
          var tmp2 = label;
          // Inline function 'com.lightningkite.kiteui.forms.fieldWithoutBorder' call
          var description_0 = description;
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(true);
          element.set_themeChoice_py59um_k$(element.get_themeChoice_22tyn3_k$().plus_duvq05_k$(LabelGapSemantic_getInstance()));
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          element.willAddChild_hz2iwc_k$(element_0);
          element_0.set_vertical_nuap32_k$(false);
          element_0.set_gap_jwjroq_k$(get_rem(0.25));
          text(themed(get_centered(element_0), LabelSemantic_getInstance()), tmp2);
          if (!(description_0 == null)) {
            var tmp0 = textPopover(get_centered(element_0), description_0);
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            var icon = Companion_getInstance_0().info_1.resize_q1xpz0_k$(get_rem_0(1));
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_1 = new (IconView())(tmp0.get_context_h02k06_k$());
            ensureOutermostElement(element_1);
            tmp0.willAddChild_hz2iwc_k$(element_1);
            element_1.set_source_3o5lkf_k$(icon);
            element_1.set_description_s1386w_k$('Info');
            element_1.onStartup_vrxh3i_k$();
            tmp0.addChild_2qpft2_k$(element_1);
          }
          element_0.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_0);
          NullableRenderer_instance.view_hsl4in_k$(context, value, module_0)(element);
          errorText(element);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      labeledView_aldyvt_k$(context, value, module_0, label, description) {
        return this.labeledView_rlcwih_k$(context, value, module_0, label, description);
      }
    }
    protoOf($).cellForm_4mayde_k$ = cellForm;
    initMetadataForObject($, 'NullableRenderer', VOID, VOID, [Renderer()]);
    NullableRendererClass = $;
  }
  return NullableRendererClass;
}
var NullableRenderer_instance;
function NullableRenderer_getInstance() {
  return NullableRenderer_instance;
}
//region block: init
NullableRenderer_instance = new (NullableRenderer())();
//endregion
//region block: exports
export {
  registerNullable as registerNullable3t9rzzkytq3g1,
};
//endregion

//# sourceMappingURL=NullableRenderer.mjs.map
